import { STRENGTH_LEVELS } from './constants';
import useCompletionProgress from './useCompletionProgress';
import { AccountStrength } from '../types';

function useAccountStrength(): AccountStrength {
  const { milestonesComplete } = useCompletionProgress();
  switch (milestonesComplete) {
    case 0:
    case 1:
    case 2:
      return STRENGTH_LEVELS[0];
    case 3:
    case 4:
      return STRENGTH_LEVELS[1];
    case 5:
    case 6:
      return STRENGTH_LEVELS[2];
    default:
      return STRENGTH_LEVELS[0];
  }
}

export default useAccountStrength;
